var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCbDomainAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79998 4H7.20002V7.20002H4V8.79998H7.20002V12.0001H8.79998V8.79998H12V7.20002H8.79998V4ZM12.8 0H3.20002C1.43265 0 0 1.43277 0 3.20002V12.8C0 14.5673 1.43265 16 3.20002 16H12.8C14.5673 16 16 14.5673 16 12.8V3.20002C16 1.43277 14.5673 0 12.8 0ZM14.4 12C14.4 13.3254 13.3256 14.4 12.0001 14.4H4C2.67456 14.4 1.60007 13.3256 1.60007 12V4C1.60007 2.67456 2.67456 1.59995 4 1.59995H12.0001C13.3256 1.59995 14.4 2.67444 14.4 4V12Z",
    fill: "#6A097D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbDomainAddIcon);
export default __webpack_public_path__ + "static/media/Cb-Domain-Add-Icon.fc85dbc9ed9538bffb0cb56f248da3de.svg";
export { ForwardRef as ReactComponent };